import * as React from 'react';
import './index.scss';
import Login from '../login';
import { Button, Drawer, Modal, message, Popover, Input, Select, Watermark, Spin } from 'antd';
import { userId, login, logout, requestDays, requestOrder, isCasual, requestCasualLogin, userPwd, setPassword, checkToken } from '../../model/api';
import UserCard from '../userCard';
import Logo2 from '../logo2';
import dateFormat from 'dateformat';
import Comments from '../comments';
import group_data from "../../datas/group.json"
import tips from '../../datas/test.json'
import {parse} from 'query-string';
import Header from '../header';

const { Option } = Select;

export default class Order extends React.Component{
  SHOW_DAYS = 7;
  _startDate = null;
  _dates = [];
  _weekday= ["星期日","星期一","星期二","星期三","星期四","星期五","星期六"];
  _stateColors = ["lightgrey", "orange", "lime"];
  _selectText = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];
  _dinnerText = ['早餐', '午餐', '晚餐(仅限当天工作至20:30以后可预定)'];
  _locations = {
    '1': ["7层东侧茶水间", "8层西侧吧台", "9层东侧吧台", "10层西侧吧台", "11层东侧吧台", "东升大厦"],
    'keg': ["7层东侧茶水间", "FIT楼"],
  }
  _deadTime = [0, 9.5*60*60*1000, 17.5*60*60*1000];

  _timeLoop = null;

  constructor(props) {
    super(props);
    let now = new Date();
    this._startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    for(let i=0; i < this.SHOW_DAYS; ++i) {
      this._dates.push(new Date(this._startDate.getTime() + i*24*60*60*1000));
    }

    this.state = {
      user: null,
      currentDateIndex: 0,
      showMemuList: false,
      curSelectingDinnerIndex: 0,
      curLocation: 0,
      daysData: null,
      showContact: false,
      showRule: false, 
      now: new Date(), 
      showLogoutConfirm: false,
      showPwdInput: false, 
      pwdInput: "",
      showTestTip: false,
      testTip: "",
      group: "",
      loading: false,
    }

    this.handleLogin = this.handleLogin.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
    this.handleShowMenu = this.handleShowMenu.bind(this);
    this.getToday = this.getToday.bind(this);
    this.renderButton = this.renderButton.bind(this);
    this.handleSetPassword = this.handleSetPassword.bind(this);
    this.handleSetLocation = this.handleSetLocation.bind(this);
  }

 async componentDidMount() {
    await this.tokenAuth()
    let parsed = parse(window.location.search);
    let group = ""
    if(parsed.group) {
      group = parsed.group;
      this.setState({group: group});
    }
    // let id = userId();
    // if(id) {
      // if(isCasual()) {
      //   requestCasualLogin({id, group}).then(data => {
      //     if(data.code == 0) {
      //       this.setState({user: data.data});
      //       this.SHOW_DAYS = 2;
      //       this.requestDays();
      //     }
      //   })
      // }else {
        // let password = userPwd();
        // login(id, password).then(data => {
        //   if(data.code == 0) {
          const data = JSON.parse(localStorage.getItem('user') || '{}')
          // console.log("local user=", data)
            if(data && data.name) {
              let person = group_data.find(d => d.name == data.name);
              if(person) {
                this.setState({
                  testTip: tips[person.group].tip
                })
              }
            }
            this.setState({user: data});
            this.SHOW_DAYS = 7;
            this.requestDays();
        //   }
        // })
      // }
    // }

    this._timeLoop = setInterval(() => this.setState({now: new Date()}), 1000);
  }

  componentWillUnmount() {
    if(this._timeLoop) {
      clearInterval(this._timeLoop);
    }
  }

  async tokenAuth() {
    // console.log("home tokenAuth work", this.props)
    const isValid = await checkToken()
    // 如果未登录跳到登录
    // console.log("home isValid=", isValid)
    if (!isValid) {
      this.props.history.push('/login')
    }
  }

  handleLogin(user) {
    this.setState({user});
    if (isCasual()) {
      this.SHOW_DAYS = 2;
    }else {
      if(user && user.name) {
        let person = group_data.find(d => d.name == user.name);
        if(person) {
          this.setState({
            testTip: tips[person.group].tip
          })
        }
      }
    }
    this.requestDays();
  }

  handleLogout() {
    logout();
    this.setState({user: null, showLogoutConfirm: false});
    this.props.history.push('/login')
  }

  handleSetPassword() {
    let id = userId();
    let old_password = userPwd();
    setPassword(id, this.state.pwdInput || "", old_password || "").then(data => {
      if(data.code == 0) {
        let user = data.data;
        this.setState({user});
        message.success("密码修改成功!");
      }else {
        message.error(data.msg);
      }
    })
    this.setState({showPwdInput: false, pwdInput: ""});
  }

  renderStateBar(state) {
    return <div className='order-date-state-bar' style={{backgroundColor: this._stateColors[state]}} />
  }

  handleSelectDate(index) {
    this.setState({currentDateIndex: index});
  }

  async requestDays(userId) {
    try {
      this.setState({ loading: true })
      const data = await requestDays(dateFormat(this._startDate, 'yyyy-mm-dd'), this.SHOW_DAYS, this.props.ckey, userId)
      // .then(data => {
      if (data.code == 0 && data.data.length == this.SHOW_DAYS) {
        let currentDateIndex = 0;
        for (let i = 0; i < data.data.length; ++i) {
          if (data.data[i].menus) {
            currentDateIndex = i;
            break;
          }
        }
        this.setState({ daysData: data.data, currentDateIndex });
      }
      // })
    } catch (err) {
      console.log("err=", err)
    } finally {
      this.setState({ loading: false })
    }
  }

  handleShowMenu(index) {
    let today = this.getToday();
    // console.log("today.locations[index]=", today.locations[index])
    // let curLocation = today && today.locations && today.locations[index] || Number(window.localStorage.getItem("dinner_location")) || 0;
    let curLocation = 0
    if (today && today.locations && (today.locations[index] || today.locations[index] === 0)) {
      curLocation = today.locations[index]
    } else {
      curLocation = Number(window.localStorage.getItem("dinner_location")) || 0
    }
    this.setState({showMemuList: true, curSelectingDinnerIndex: index, curLocation})
  }

  handleSetLocation(loc) {
    this.setState({curLocation: loc})
    window.localStorage.setItem("dinner_location", loc)
  }

  renderButton(index) {
    let today = this.getToday();
    let menuData = today.menus;
    let date = new Date(today.day + "T00:00:00+08:00");
    let outTime = date.getTime() + this._deadTime[index];
    let last = (outTime - this.state.now.getTime()) / 1000 / 60;

    let selected = today.selected[index];
    if(selected >= 0 && selected >= menuData[index].length) {
      selected = -1;
    }
    let location = today.locations &&  this._locations[this.props.ckey][today.locations[index]] || "";
    return (
      <Button className='order-order-bt' key={index} onClick={last > 0 ? () => this.handleShowMenu(index) : undefined}>
        <div className='order-order-inner'>
          <div className='order-order-title'>{this._dinnerText[index]}</div>
          {last > 0 && last < 60 && <div className='order-order-timetip'>{`距点餐结束还有 ${last < 1 ? "不足 1" : last.toFixed()} 分钟`}</div>}
          {last <= 0 && <div className='order-order-timetip' style={{color: "red"}}>{`点餐已结束`}</div>}
          { selected >= 0 ? (<div className='order-order-select'><span>{`已选 ${this._selectText[selected]}: `}</span>{menuData[index][selected]?.list?.map(m => m.name).join(', ')}</div>) : 
            (<div className='order-order-select-no'>{`未点餐，单击选餐`}</div>)}
          { selected >= 0 && location && <div className='order-order-location'>{`就餐地址: ${location}`}</div>}
        </div>
      </Button>
    )
  }

  handleSelectMenu(index) {
    const { daysData, currentDateIndex, curSelectingDinnerIndex, curLocation, user } = this.state;
    let today = this.getToday();
    if(today.selected) {
      let selected = [...today.selected];
      selected[curSelectingDinnerIndex] = index;
      let locations = today.locations ? [...today.locations] : [0, 0, 0];
      locations[curSelectingDinnerIndex] = curLocation;
      requestOrder(today.day, selected, locations, user.id).then(data => {
        if(data.code == 0) {
          today = {...today, selected, locations};
          let newDays = [...daysData];
          newDays[currentDateIndex] = today;
          if(selected == -1) {
            message.success("订餐已取消");
          }else {
            message.success("订餐成功");
          }
          this.setState({showMemuList: false, daysData: newDays})
        }else {
          message.error("订餐失败了，请重新选择...");
        }
      })
    }
  }

  getToday(index) {
    const { daysData, currentDateIndex } = this.state;
    return daysData ? daysData[index == undefined ? currentDateIndex : index] : null;
  }

  renderMenuItem(index) {
    const { curSelectingDinnerIndex } = this.state;
    let today = this.getToday();
    return (
      <Button className='order-menu-item' key={index} onClick={() => this.handleSelectMenu(index)}>
        { index == -1 && "取消, 不订餐" }
        { index != -1 && <div className='order-menu-item-text'><span>{this._selectText[index]}</span>{`: ${today?.menus[curSelectingDinnerIndex][index]?.list?.map(m => m.name).join(', ')}`}</div>}
      </Button>
    )
  }

  // popoverContent() {
  //   return <div>
  //     {/* <div className='order-popover-item' onClick={() => this.setState({showPwdInput: true, pwdInput: ""})}>{this.state.user.is_encrypted ? "修改密码": "设置密码"}</div> */}
  //     <div className='order-popover-item' onClick={() => this.setState({showLogoutConfirm: true})}>退出登录</div>
  //   </div>
  // }

  // 切换账号，菜单
  changeUser = (data) => {
    // console.log("changeuser data=", data)
    this.setState({ user: data });
    this.SHOW_DAYS = 7;
    this.requestDays(data.id);
  }

  render() {
    const { user, currentDateIndex, showMemuList, curSelectingDinnerIndex, showRule, daysData, testTip, loading } = this.state;
    const today = this.getToday();
    return (
      <div className='order'>
        {
          !!user && (
            <div className='order-inner'>
              <Header {...this.props} type="order" />
              {/* <div className='order-top'>
                <div className='order-logo'><Logo2 /></div>
                <Popover placement="bottomLeft" content={this.popoverContent()} trigger={['click']}>
                  <div className='order-logout' ><i className='fa fa-ellipsis-h' /></div>
                </Popover>
              </div> */}
              <div className='order-user'>
                <UserCard data={user} isCasual={isCasual()} toChangeUser={this.changeUser} />
              </div>
             <Spin spinning={loading} indicator={<></>} tip="餐食正在向你奔来...">
              <div className='order-dates'>
                {this._dates?.map((date, i) => {
                  if( i >= this.SHOW_DAYS) return null;
                  let day = this.getToday(i);
                  return (
                    <div className='order-date' key={i} style={{color: i==currentDateIndex?"#0095ff":"dimgrey", fontWeight: i==currentDateIndex?"bold":"normal"}} onClick={() => this.handleSelectDate(i)}>
                      <div className='order-date-date'>{ dateFormat(date, 'yy/mm/dd')}</div>
                      <div className='order-date-week'>{ this._weekday[date.getDay()]}</div>
                      <div className='order-date-state'>
                        {this.renderStateBar(day && day.selected ? (day.selected[0] >= 0 ? 2 : 1) : 0)}
                        {this.renderStateBar(day && day.selected ? (day.selected[1] >= 0 ? 2 : 1) : 0)}
                        {this.renderStateBar(day && day.selected ? (day.selected[2] >= 0 ? 2 : 1) : 0)}
                      </div>
                    </div>
                  )
                })}
              </div>
              {
                daysData && (
                  <div className='order-order'>
                    { today && today.menus && <div className='order-order-top-title'>{`请点餐 (${dateFormat(this._dates[currentDateIndex], 'yyyy/mm/dd')} ${this._weekday[this._dates[currentDateIndex].getDay()]})`}</div>}
                    { today && today.menus && today.menus.map((_, i) => {
                      return this.renderButton(i)
                    })}
                    {
                      today && !today.menus && <div className='order-order-cannt'>今天不能点餐哦...</div>
                    }
                  </div>
                )
              }
              </Spin>
              {/* {!isCasual() && <div className='order-comments'><Comments ckey={this.props.ckey} /></div>} */}
              <div className='order-comments'><Comments ckey={this.props.ckey} /></div>
              <div className='order-tools'>
                {/* {!isCasual() && <div className='order-tool' onClick={() => this.props.history.push('/statistics?ckey='+this.props.ckey+"&group"+this.state.group)}><i className='fa fa-chart-pie' /></div>} */}
                {/* <div className='order-tool' onClick={() => this.props.history.push('/statistics?ckey='+this.props.ckey+"&group"+this.state.group)}><i className='fa fa-chart-pie' /></div> */}
                <div className='order-tool' onClick={() => this.setState({showRule: true})}><i className='fa fa-question' /></div>
              </div>
              {
                today && today.menus && (
                  <Drawer
                    title={<div>{`选择${this._dinnerText[curSelectingDinnerIndex]}`}
                      { this._locations[this.props.ckey] && (
                        <div style={{ 
                          float: 'right'
                        }} >
                          <Select value={this.state.curLocation} style={{ width: 120 }} onChange={v => this.handleSetLocation(v)}>
                            {
                              this._locations[this.props.ckey]?.map((d, i) => <Option key={i} value={i}>{d}</Option>)
                            }
                          </Select>
                        </div>
                      )}</div>}
                    placement="bottom"
                    closable={false}
                    onClose={() => this.setState({showMemuList: false})}
                    open={showMemuList}
                    key="bottom"
                    height="70%"
                  >
                    {this.renderMenuItem(-1)}
                    {today.menus[curSelectingDinnerIndex]?.map((_, i) => this.renderMenuItem(i))}
                  </Drawer>
                )
              }
              <Drawer
                title={`订餐须知`}
                placement="bottom"
                closable={false}
                onClose={() => this.setState({showRule: false})}
                open={showRule}
                key="rule"
                height="60%"
              >
                <p>早餐预订截止时间：前一天 24:00</p>
                <p>午餐预定截止时间：当天 09:30</p>
                <p>晚餐预定截止时间：当天 17:30</p>
                <p>蔬菜沙拉含：优质蛋白（鸡胸、虾仁）、水煮鸡蛋、紫薯粒、南瓜粒、玉米粒、小番茄、生菜叶、紫甘蓝、黑芝麻</p>
              </Drawer>
              <Modal
                title="退出确认"
                open={this.state.showLogoutConfirm}
                onOk={this.handleLogout}
                onCancel={() => this.setState({showLogoutConfirm: false})}
                okText="退出">
                  <div>确认退出登录么？</div>
              </Modal>
              <Modal
                title="设置密码"
                open={this.state.showPwdInput}
                onOk={this.handleSetPassword}
                onCancel={() => this.setState({showPwdInput: false})}>
                  <Input placeholder="新密码" value={this.state.pwdInput} onChange={e => this.setState({pwdInput: e.target.value})} onPressEnter={this.handleSetPassword} />
              </Modal>
              <Modal
                title="节约提示"
                open={this.state.showTestTip}
                onOk={() => this.setState({showTestTip: false})}
                onCancel={() => this.setState({showTestTip: false})}
                maskClosable={false}
                okText="好的"
                cancelText="取消">
                  <div dangerouslySetInnerHTML={{__html: testTip}} />
              </Modal>
            </div>
          ) 
          // : (
          //   <Login onLogin={this.handleLogin} ckey={this.props.ckey} group={this.state.group} />
          // )
        }
      </div>
    )
  }
}